"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "getChat", {
  enumerable: true,
  get: function () {
    return _create.getChat;
  }
});
Object.defineProperty(exports, "longChatPane", {
  enumerable: true,
  get: function () {
    return _longChatPane.longChatPane;
  }
});
Object.defineProperty(exports, "shortChatPane", {
  enumerable: true,
  get: function () {
    return _shortChatPane.shortChatPane;
  }
});
var _shortChatPane = require("./shortChatPane");
var _longChatPane = require("./longChatPane");
var _create = require("./create");
//# sourceMappingURL=main.js.map